import React, { Component } from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import Animation from "./animation/animation.json";
import "./style.scss";

// import {CyclingStep} from "./components/CyclingStep";
// import {ConstantStep} from "./components/ConstantStep";
// import {RenderLine} from "./components/RenderLine";
// import {RenderTime} from "./components/RenderTime";
//
// import FastForwardIcon from "./img/Fastforward-icon.svg";

export class RunTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      timeoutInterval: 10,
      sequenceInterval: 60
    };

    this.playerWrapper = React.createRef();
    this.player = React.createRef();
  }

  setCustomTime = (time) => {
    this.props.setCurrentTime({
      id: this.props.id,
      currentTime: time
    });
  };

  updateTime = () => {

    let updatedCurrentTime = this.props.currentTime + this.state.sequenceInterval;
    let updatedElapsedTime = this.props.totalElapsedTime + this.state.sequenceInterval;

    if(updatedElapsedTime >= this.props.totalTime){

      window.clearTimeout(this.timeout);

      this.props.setRunning({
        id: this.props.id,
        running: false
      });
      this.props.setCurrentTime({
        id: this.props.id,
        currentTime: this.props.totalTime
      });
      this.props.setTotalElapsedTime({
        id: this.props.id,
        totalElapsedTime: this.props.totalTime
      });

      this.player.current.stop()

    } else {

      this.props.setCurrentTime({
        id: this.props.id,
        currentTime: updatedCurrentTime
      });
      this.props.setTotalElapsedTime({
        id: this.props.id,
        totalElapsedTime: updatedElapsedTime
      });

      if (this.props.running) {
        this.timeout = setTimeout(this.updateTime, this.state.timeoutInterval);
      }
    }
  };

  convertTimeStringtoSeconds = (timestring) => {
    const [str1, str2, str3] = timestring.split(":");

    const val1 = Number(str1);
    const val2 = Number(str2);
    const val3 = Number(str3);

    if (!isNaN(val1) && isNaN(val2) && isNaN(val3)) {
      return val1;
    }

    if (!isNaN(val1) && !isNaN(val2) && isNaN(val3)) {
      return val1 * 60 + val2;
    }

    if (!isNaN(val1) && !isNaN(val2) && !isNaN(val3)) {
      return val1 * 60 * 60 + val2 * 60 + val3;
    }

    return 0;
  };

  componentDidMount() {
    // Resize the scene and attach the resize method to the window resize event
    this.updateTime();

    this.props.setRunning({
      id: this.props.id,
      running: true
    });
    this.props.setDurations({
      id: this.props.id,
      durations: this.props.sequence.flatMap((step) => {
        if (step.type === "constant") {
          return step.duration;
        }
        if (step.type === "cycling") {
          return step.subSteps.map((subStep) => {
            return subStep.duration;
          });
        }
      })
    });
  }
  componentWillUnmount() {
    window.clearTimeout(this.timeout);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.running !== this.props.running && this.props.running) {
      this.updateTime();
    }
    if(prevProps.durations !== this.props.durations){
      this.props.setTotalTime({
        id: this.props.id,
        totalTime: this.props.sequence
          .flatMap((step) =>{
            if(step.hasOwnProperty("subSteps")){
              return step.subSteps.map((subStep)=>(this.convertTimeStringtoSeconds(subStep.duration) * step.repeat))
            } else {
              return this.convertTimeStringtoSeconds(step.duration)
            }
          })
          .reduce((prev, next) => prev + next)
      });
    }
  }

  render() {
    return (
      <div
      className="run-table-animation"
      ref={this.playerWrapper}
      style={{
        position: "relative"
      }}>
        <Player
          ref={this.player}
          loop={true}
          autoplay={true}
          controls
          src={Animation}
        ></Player>
      </div>
    );
  }
}
